export const SET_LOADING = 'SET_LOADING';
export const SET_ORDERS_LOADING = 'SET_ORDERS_LOADING';
export const ADD_STORES = 'ADD_STORES';
export const ADD_ORDERS = 'ADD_ORDERS';
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE';
